var $ = require('jquery');

export default () => {
  $('.js-toggle-link').each((i, el) => {
    el.addEventListener('click', e => {
      e.preventDefault();
      $(el).parent().parent().find('.js-toggle-content').each((i, el) => {
        el.classList.toggle('js-toggle-content--hidden');
      });
    });
  });
}
